
export const LOAD_USER_PERMISSIONS_ROLES_DATA_IN_PROGRESS = "LOAD_USER_PERMISSIONS_ROLES_DATA_IN_PROGRESS";
export const loadUserPermissionsRolesDataInProgress = () => ({
  type: LOAD_USER_PERMISSIONS_ROLES_DATA_IN_PROGRESS,
});

export const LOAD_USER_PERMISSIONS_ROLES_DATA_SUCCESS = "LOAD_USER_PERMISSIONS_ROLES_DATA_SUCCESS";
export const loadUserPermissionsRolesDataSuccess = (data) => ({
  type: LOAD_USER_PERMISSIONS_ROLES_DATA_SUCCESS,
  payload: { data },
});

export const LOAD_USER_PERMISSIONS_ROLES_DATA_FAILURE = "LOAD_USER_PERMISSIONS_ROLES_DATA_FAILURE";
export const loadUserPermissionsRolesDataFailure = () => ({
  type: LOAD_USER_PERMISSIONS_ROLES_DATA_FAILURE,
});

export const LOAD_USER_PERMISSIONS_ROLES_NOT_FOUND = "LOAD_USER_PERMISSIONS_ROLES_NOT_FOUND";
export const loadUserPermissionsRolesNotFound = (data) => ({
  type: LOAD_USER_PERMISSIONS_ROLES_NOT_FOUND,
  payload: { data },
});
